//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getSocialMediaSettings } from '@redux/selectors/getSocialMediaSettings';

const getPinterestSettings = createSelector(
  getSocialMediaSettings,
  (settings) => settings.pinterest,
);

export const getIsPinterestConnected = createSelector(
  getPinterestSettings,
  (pinterestSettings) => pinterestSettings.isConnected,
);

export const getPinterestIsFetchingSettings = createSelector(
  getPinterestSettings,
  (pinterestSettings) => pinterestSettings.flags.isFetchingSettings,
);

export const getIsPinterestReconnecting = createSelector(
  getPinterestSettings,
  (pinterestSettings) => pinterestSettings.flags.isReconnecting,
);

export const getPinterestErrors = createSelector(
  getPinterestSettings,
  (pinterestSettings) => pinterestSettings.errors,
);

export const getShouldShowPermissions = createSelector(
  getPinterestSettings,
  (pinterestSettings) => pinterestSettings.shouldShowPermissions,
);

export const getIsPinterestLoading = createSelector(
  getPinterestSettings,
  getIsPinterestReconnecting,
  (pinterestSettings, isPinterestReconnecting) => {
    const {
      flags: { isConnecting, isFetchingSettings, isDisconnecting },
    } = pinterestSettings;

    return (
      isConnecting ||
      isDisconnecting ||
      isFetchingSettings ||
      isPinterestReconnecting
    );
  },
);
